import { useEffect, useState } from "react";
import "./App.css";
import { ethers } from "ethers";
import faucetContract from "./ethereum/faucet";


function App() {
  const [walletAddress, setWalletAddress] = useState("");
  const [signer, setSigner] = useState();
  const [fcContract, setFcContract] = useState();
  const [withdrawError, setWithdrawError] = useState("");
  const [withdrawSuccess, setWithdrawSuccess] = useState("");
  const [transactionData, setTransactionData] = useState("");

  useEffect(() => {
    getCurrentWalletConnected();
    addWalletListener();
  }, [walletAddress]);

  const connectWallet = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      try {
        /* get provider */
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        /* get accounts */
        const accounts = await provider.send("eth_requestAccounts", []);
        /* get signer */
        setSigner(provider.getSigner());
        /* local contract instance */
        setFcContract(faucetContract(provider));
        /* set active wallet address */
        setWalletAddress(accounts[0]);
      } catch (err) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      console.log("Please install MetaMask or Enkrypt");
    }
  };

  const getCurrentWalletConnected = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      try {
        /* get provider */
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        /* get accounts */
        const accounts = await provider.send("eth_accounts", []);
        if (accounts.length > 0) {
          /* get signer */
          setSigner(provider.getSigner());
          /* local contract instance */
          setFcContract(faucetContract(provider));
          /* set active wallet address */
          setWalletAddress(accounts[0]);
        } else {
          console.log("Connect to MetaMask or Enkrypt using the Connect Wallet button");
        }
      } catch (err) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      console.log("Please install MetaMask or Enkrypt");
    }
  };

  const addWalletListener = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      window.ethereum.on("accountsChanged", (accounts) => {
        setWalletAddress(accounts[0]);
      });
    } else {
      /* MetaMask is not installed */
      setWalletAddress("");
      console.log("Please install MetaMask or Enkrypt");
    }
  };

  const getOCTHandler = async () => {
    setWithdrawError("");
    setWithdrawSuccess("");
    try {
      const fcContractWithSigner = fcContract.connect(signer);
      const resp = await fcContractWithSigner.requestTokens();
      setWithdrawSuccess("Daily Claim Tdog Token Succeeded - Please claim again after 24 hours!");
      setTransactionData(resp.hash);
    } catch (err) {
      setWithdrawError(err.message);
    }
  };

  return (
    <div>
      <nav className="navbar">
        <div className="container">
          <div className="navbar-brand">
          
            <h1 className="navbar-item is-size-4">&#128021; Tdog is a fully decentralized ThunderCore TT20 token. Totally free money for everyone to claim.</h1>
          </div>
          
          <div id="navbarMenu" className="navbar-menu">
            <div className="navbar-end is-align-items-center">
              <button
                className="button is-white connect-wallet"
                onClick={connectWallet}
              >
                <span className="is-link has-text-weight-bold">
                  {walletAddress && walletAddress.length > 0
                    ? `Connected: ${walletAddress.substring(
                        0,
                        6
                      )}...${walletAddress.substring(38)}`
                    : "Connect Wallet"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <nav className="navbar">
        <div className="container">
          
          
          <div id="navbarMenu" className="navbar-menu">
            <div className="navbar-brand">
              <button
                className="button is-white connect-wallet"
                onClick={connectWallet}
              >
                <span className="is-link has-text-weight-bold">
                  {walletAddress && walletAddress.length > 0
                    ? `Connected: ${walletAddress.substring(
                        0,
                        6
                      )}...${walletAddress.substring(38)}`
                    : "Connect Wallet"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>
      <div className="navbar-brand">
      <a href="https://tdogtoken.github.io/tdog">
        <button>Home</button>
      </a>
      -
      <a href="https://laserswap.finance/swap?inputCurrency=0xda1A573d6B19F4c5207f199A1d5e97aBA02eed1F" target="_blank" rel="noopener noreferrer">
        <button>Trade Tdog</button>
      </a>
      -
      <a href="https://viewblock.io/thundercore/address/0xda1A573d6B19F4c5207f199A1d5e97aBA02eed1F?tab=holders" target="_blank" rel="noopener noreferrer">
        <button>Tdog Holder</button>
      </a>
      -
      <a href="https://viewblock.io/thundercore/address/0xda1a573d6b19f4c5207f199a1d5e97aba02eed1f?tab=code" target="_blank" rel="noopener noreferrer">
        <button>Contract Code</button>
      </a>
      -
      <a href="https://www.tradingview.com/chart/ud8ZrnPY/" target="_blank" rel="noopener noreferrer">
        <button>Bitcoin Signal Chart</button>
      </a>
      -
      <a href="https://metamask.io/download/" target="_blank" rel="noopener noreferrer">
        <button>Download MetaMask Wallet</button>
      </a>
      -
      <a href="https://www.enkrypt.com/" target="_blank" rel="noopener noreferrer">
        <button>Download Enkrypt Wallet</button>
      </a>
      
    </div>
    <div className="navbar-brand">
      
      
      <a href="https://youtu.be/UXLisyo_a00" target="_blank" rel="noopener noreferrer">
        <button>How to add Tdog to MetaMask</button>
        </a>
        -
      <a href="https://youtu.be/zZYazWjPSdI" target="_blank" rel="noopener noreferrer">
        <button>How to add Tdog to Enkrypt </button>
      </a>
      -
      <a href="https://youtu.be/xAdRrzoNSX0" target="_blank" rel="noopener noreferrer">
        <button>How to claim Tdog</button>
      </a>
      -
      <a href="https://youtu.be/sQLJl9Ej60w" target="_blank" rel="noopener noreferrer">
        <button>How to Buy Sell Tdog</button>
      </a>
      
    </div>
    
    
      <section className="hero is-fullheight">
        <div className="faucet-hero-body">
          <div className="container has-text-centered main-content">
            <h1 className="title is-1">&#128021; Airdrop: Total 150 billion Tdog Tokens</h1>
            <p>Claim free 100000 Tdog Daily.</p>
            <div className="mt-5">
              {withdrawError && (
                <div className="withdraw-error">{withdrawError}</div>
              )}
              {withdrawSuccess && (
                <div className="withdraw-success">{withdrawSuccess}</div>
              )}{" "}
            </div>
            <div className="box address-box">
              <div className="columns">
                <div className="column is-four-fifths">
                  <input
                    className="input is-medium"
                    type="text"
                    placeholder="Please connect your wallet address (0x...)"
                    defaultValue={walletAddress}
                  />
                </div>
                <div className="column">
                  <button
                    className="button is-link is-medium"
                    onClick={getOCTHandler}
                    disabled={walletAddress ? false : true}
                  >
                    Claim free Tdog
                  </button>
                </div>
              </div>
              <article className="panel is-grey-darker">
                <p className="panel-heading">Please Use MetaMask Wallet or Enkrypt Wallet</p>
                <div className="panel-block">
                  <p>
                    {transactionData
                      ? `Transaction hash: ${transactionData}`
                      : "--"}
                  </p>
                </div>
              </article>
              
                
                
             
            </div>
          </div>
        </div>
      </section>
      <div className="container has-text-centered main-content">
            &#128021; Tdog Platform @ 2022-2057 All Right Reserved.
   
      </div>
    </div>
  );
}

export default App;
